import injectSheet from 'react-jss';

import styles from './ValidationSection.styles';

const ValidationSection = ({ classes, children, ...props }) => (
  <div className={classes.validationSection}>{children}</div>
);

export default injectSheet(styles)(ValidationSection);
